import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface State {
    isSocialModelOpen: boolean;
    shareUrl: string | null;
    showPrivacyModal: boolean;
}

const initState: State = {
    isSocialModelOpen: false,
    shareUrl: null,
    showPrivacyModal: false,
};

const slice = createSlice({
    name: "Application",
    initialState: initState,
    reducers: {
        setSocialModal: (state: State, action: PayloadAction<boolean>) => {
            state.isSocialModelOpen = action.payload;
            if (!action.payload) {
                state.shareUrl = null;
            }
        },
        setShareUrl: (state: State, action: PayloadAction<string | null>) => {
            state.shareUrl = action.payload;
        },
        setPrivacyModal: (state: State, action: PayloadAction<boolean>) => {
            state.showPrivacyModal = action.payload;
        },
    },
    extraReducers: (builder) => {},
});

export const { setSocialModal, setShareUrl, setPrivacyModal } = slice.actions;
export default slice.reducer;
